import { useState, type ReactNode } from 'react';
import { Dialog, DialogContent, DialogTrigger } from './dialog';
import { Button } from './button';

interface ConfirmDialogProps {
  trigger: ReactNode;
  title: string;
  /** Plain-language explanation of what will happen — never just "Are you sure?". */
  description: string;
  confirmLabel: string;
  variant?: 'primary' | 'danger';
  onConfirm: () => unknown;
}

export function ConfirmDialog({ trigger, title, description, confirmLabel, variant = 'primary', onConfirm }: ConfirmDialogProps) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const handleConfirm = async () => {
    setBusy(true);
    try {
      await onConfirm();
      setOpen(false);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent title={title} description={description}>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => setOpen(false)} disabled={busy}>
            Cancel
          </Button>
          <Button variant={variant} onClick={handleConfirm} disabled={busy}>
            {confirmLabel}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
